import * as tracking from '../../tracking';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import Moment from 'moment';

import {SCHEDULING_VIEW} from '../../constants';
import {getDayData, getDayDataLight, MIN_DATE_YEAR, YEAR_SPAN} from './canvas-timeline/canvas_timeline_util';
import CanvasPeopleScheduling from './people-scheduling/canvas_people_scheduling';
import CanvasProjectsScheduling from './projects-scheduling/canvas_projects_scheduling';
import Util from '../../forecast-app/shared/util/util';
import {hasPermission} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';

class CanvasScheduling extends Component {
	constructor(props) {
		super(props);
		//Take zoom level from localStorage, if it is not set, set window to 14 days
		let windowSizeInHours = localStorage.getItem('schedulingRedesignVisibleDayCount') || 14;
		//When you open the page 25% of window should show the past, 75% the future
		const startDate = Moment().subtract(windowSizeInHours * 0.25, 'days');
		const endDate = Moment().add(windowSizeInHours * 0.75, 'days');

		const minDate = Moment().year(MIN_DATE_YEAR).startOf('year');
		const maxDate = minDate.clone().add(YEAR_SPAN, 'years').endOf('year');
		const dayData = getDayData(minDate, maxDate);
		const dayDataLight = getDayDataLight(minDate, maxDate);

		this.peopleSchedulingHeatmapCache = new Map();
		this.peopleSchedulingExpansionMap = new Map();
		this.projectSchedulingExpansionMap = new Map();

		let isProjectTabSelected = localStorage.getItem('schedulingRedesignIsProjectTabSelected') === 'true';
		if (window.location.hash) {
			let tab = window.location.hash.substring(1);
			if (tab.includes(SCHEDULING_VIEW.PEOPLE)) {
				isProjectTabSelected = false;
			}
			if (tab.includes(SCHEDULING_VIEW.PROJECTS)) {
				isProjectTabSelected = true;
			}
		}
		if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
			isProjectTabSelected = false;
		}
		if (props.isProjectTimeline) {
			isProjectTabSelected = true;
		}

		Util.localStorageSetItem('schedulingRedesignIsProjectTabSelected', isProjectTabSelected && !props.isProjectTimeline);

		this.state = {
			startDate,
			endDate,
			zoomLevel: 8,
			dayData,
			dayDataLight,
			isProjectTabSelected,
			browserMessageHidden: false,
		};
	}

	componentDidMount() {
		document.title = 'Scheduling - Forecast';
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (window.location.hash) {
			const tab = window.location.hash.substring(1);
			let isProjectTabSelected = this.state.isProjectTabSelected;
			if (tab.includes(SCHEDULING_VIEW.PEOPLE)) {
				isProjectTabSelected = false;
			}
			if (tab.includes(SCHEDULING_VIEW.PROJECTS)) {
				isProjectTabSelected = true;
			}
			if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
				isProjectTabSelected = false;
			}
			if (nextProps.isProjectTimeline) {
				isProjectTabSelected = true;
			}
			if (isProjectTabSelected !== this.state.isProjectTabSelected) {
				Util.localStorageSetItem('schedulingRedesignIsProjectTabSelected', isProjectTabSelected);
				const filterString = `canvas-scheduling-filters-v3-${isProjectTabSelected ? 'projects' : 'people'}`;
				if (this.state.data && localStorage.getItem(filterString)) {
					const filters = JSON.parse(localStorage.getItem(filterString));
					this.setState({isProjectTabSelected, filters});
				} else {
					this.setState({isProjectTabSelected});
				}
			}
		}
	}

	setTimeline(timeline) {
		this.timeline = timeline;
	}

	onTabClick(isProjectTab) {
		let {isProjectTabSelected} = this.state;
		Util.localStorageSetItem('schedulingRedesignIsProjectTabSelected', isProjectTab);
		if (isProjectTab === isProjectTabSelected) return;
		isProjectTabSelected = isProjectTab;
		window.location.hash = isProjectTabSelected ? SCHEDULING_VIEW.PROJECTS : SCHEDULING_VIEW.PEOPLE;
		this.setState({
			isProjectTabSelected,
		});
	}

	hideBrowserMessage() {
		this.setState({browserMessageHidden: true});
	}

	getChromeWarning() {
		const browserSpecs = Util.getBrowserSpecs();
		if (!this.state.browserMessageHidden && browserSpecs.name === 'Chrome' && browserSpecs.version === '77') {
			tracking.trackEvent('scheduling-chrome-warning-shown');
			return (
				<div className="scheduling-browser-message-background">
					<div className="scheduling-browser-message">
						<button className="close-button" onClick={this.hideBrowserMessage.bind(this)} />
						<div className="browser-message-text">
							Please restart your browser to upgrade to the latest version of Google Chrome.
						</div>
						<div className="browser-message-text">This will resolve the current issues with Scheduling.</div>
						<div className="browser-message-text">
							If the problem remains please make sure you have the latest version (v78).
						</div>
						<a target="_blank" href="https://support.google.com/chrome/answer/95414" rel="noopener noreferrer">
							Guide to update Chrome
						</a>
					</div>
				</div>
			);
		}
	}

	render() {
		const shareUrl = this.props.match.params.shareUrl;
		const {isProjectTimeline} = this.props;
		const {isProjectTabSelected, data, dayData, dayDataLight, isPeopleSchedulingInActualMode} = this.state;

		return (
			<div key={'c2'} className={`canvas-scheduling ${shareUrl ? 'shared' : ''}`}>
				{this.props.children}
				{this.getChromeWarning()}
				{isProjectTabSelected ? (
					<CanvasProjectsScheduling
						match={this.props.match}
						data={data}
						setTimeline={this.setTimeline.bind(this)}
						searchFilterValue={this.state.searchFilterValue}
						dayData={dayData}
						dayDataLight={dayDataLight}
						showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
						isProjectTimeline={isProjectTimeline}
						timelineHeatmapData={this.state.timelineHeatmapData}
						projectId={this.props.match.params.projectId}
						groupId={this.props.match.params.groupId}
						shareUrl={shareUrl}
						heatmapCache={this.peopleSchedulingHeatmapCache}
						expansionMap={this.projectSchedulingExpansionMap}
						onTabClick={this.onTabClick.bind(this)}
						isProjectTabSelected={true}
					/>
				) : (
					<CanvasPeopleScheduling
						data={data}
						setTimeline={this.setTimeline.bind(this)}
						dayData={dayData}
						dayDataLight={dayDataLight}
						showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
						isInActualMode={isPeopleSchedulingInActualMode}
						options={this.state.peopleSchedulingOptions}
						startDate={this.timeline ? this.timeline.startDate : undefined}
						heatmapCache={this.peopleSchedulingHeatmapCache}
						expansionMap={this.peopleSchedulingExpansionMap}
						onTabClick={this.onTabClick.bind(this)}
						isProjectTabSelected={false}
					/>
				)}
			</div>
		);
	}
}

export default injectIntl(withRouter(CanvasScheduling));
